module.exports = __webpack_public_path__ + "static/media/infinitydots.d7e6db83.svg";